import React from 'react'
import { Pressable, StyleSheet } from 'react-native'

import { StyledTextButton } from './styled'
import { ButtonProps } from './types'

import { Box } from '../Box'
import { Icon } from '../Icon'
import { FontSizes } from '../Text'

type TextButtonProps = Pick<ButtonProps, 'onPress' | 'title' | 'type'> & {
  size?: FontSizes
  icon?: string
  bold?: boolean
  underline?: boolean
  testID?: string
}

const styles = StyleSheet.create({
  gap4: {
    gap: '4px',
  },
})

export const TextButton = ({
  icon,
  onPress,
  size,
  title,
  bold = true,
  underline = true,
  type = 'primary',
  testID,
}: TextButtonProps): JSX.Element => (
  <Pressable onPress={onPress} testID={testID}>
    <Box flexDirection='row' align='center' style={styles.gap4}>
      {icon && (
        <Box>
          <Icon name={icon} size={20} color={type} />
        </Box>
      )}
      <StyledTextButton
        bold={bold}
        underline={underline}
        fontSize={size}
        color={type}
        selectable={false}
      >
        {title}
      </StyledTextButton>
    </Box>
  </Pressable>
)
